// 定点-航线列表接口
import req from '../index'

//获取管线
export const GetRoutesList = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.RoutesList_Get', params)
}

//上传坐标
export const ImportPoint = (params) => {
  return req.file('api/admin.php?s=Admin.Airport.RoutesPoint_Import', params)
}

//上传航线文件
export const ImportRoute = (params) => {
  return req.file('api/admin.php?s=Admin.Airport.AccurateRetake_Import', params, 90000)
}

//新增 | 编辑 管线
export const SetRoutes = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.RoutesInfo_Set', params)
}

//删除管线
export const DelRoutes = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.RoutesInfo_Del', params)
}

//定点巡航-起飞高度设置
export const TakeoffAltitude = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.Takeoff_altitude_Edit', params)
}

//临时执行
export const AirTemporary = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.Temporary', params)
}

//临时执行
export const M3Temporary = (params) => {
  return req.post('api/admin.php?s=Admin.M3Drone.startWayLine', params)
}

//上传标识桩
export const IdentifyStakeFun = (params) => {
  return req.file('api/admin.php?s=Admin.Airport.RoutesMark_Import', params)
}

// 导出管线、航点、标识桩
export const ExportWaypointsFun = (params) => {
  return req.get('api/admin.php?s=Admin.Airport.Routes_PointExport', params)
}


// 获取定点类型-风险设置列表
export const getRiskSetListAPI = (params) => {
  return req.get('api/admin.php?s=Admin.Airport.AccurateRetakeList_Get', params)
}


//获取风险开关信息
export const getRiskSwitchInfoFun = (params) => {
  return req.get('api/admin.php?s=Admin.Airport.AccurateRetake_Info', params)
}

//设置风险开关信息
export const setRiskSwitchInfoFun = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.AccurateRetake_Set', params)
}

//上传图片
export const submitPictureApi = (params) => {
  return req.file('api/admin.php?s=Admin.Airport.UploadAccurateRetake_pic', params)
}

//下载航线文件
export const downloadRouteApi = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.Wayfile_Export', params)
}

